<div [hidden]="link.hide">
  @if (link.links) {
    <mat-accordion>
      <mat-expansion-panel
        class="mat-elevation-z"
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
        >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <a mat-list-item>
              <mat-icon matListItemIcon>{{link.icone}}</mat-icon>
              <span matListItemTitle>{{link.label }}</span>
            </a>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (linkFilho of link.links; track linkFilho; let last = $last) {
          <ui-master-item
            [link]="linkFilho"
            (handleLinkClick)="handleLinkClick.emit(linkFilho); panelOpenState=false;"
          ></ui-master-item>
          @if (!last) {
            <mat-divider></mat-divider>
          }
        }
      </mat-expansion-panel>
    </mat-accordion>
  } @else {
    <a
      mat-list-item
      [routerLink]="getRota(link)"
      [routerLinkActiveOptions]="{ exact: true}"
      routerLinkActive="active"
      [title]="link.label"
      (click)="handleLinkClick.emit(link); execRota(link)"
      [disabled]="link.disable"
      >
      <mat-icon matListItemIcon>{{link.icone}}</mat-icon>
      <span matListItemTitle>{{link.label}}</span>
    </a>
  }
</div>
